(function() {
  // Countdown
  document.querySelectorAll('.pe-countdown').forEach(function(el) {
    var target = new Date(el.dataset.end).getTime();
    if (isNaN(target)) { el.style.display = 'none'; return; }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.classList.add('pe-countdown--ended');
        ['days', 'hours', 'minutes', 'seconds'].forEach(function(u) {
          var e = el.querySelector('[data-unit="' + u + '"]');
          if (e) e.textContent = '0';
        });
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.querySelector('[data-unit="days"]').textContent = d;
      el.querySelector('[data-unit="hours"]').textContent = h < 10 ? '0' + h : h;
      el.querySelector('[data-unit="minutes"]').textContent = m < 10 ? '0' + m : m;
      el.querySelector('[data-unit="seconds"]').textContent = s < 10 ? '0' + s : s;
    }
    tick();
    setInterval(tick, 1000);
  });

  // Live viewers
  document.querySelectorAll('.pe-viewers').forEach(function(el) {
    var min = parseInt(el.dataset.min, 10) || 10;
    var max = parseInt(el.dataset.max, 10) || 30;
    var refresh = (parseInt(el.dataset.refresh, 10) || 15) * 1000;
    var countEl = el.querySelector('.pe-viewers__count');
    function update() { countEl.textContent = Math.floor(Math.random() * (max - min + 1)) + min; }
    update();
    setInterval(update, refresh);
  });

  // Delivery estimate
  document.querySelectorAll('.pe-delivery').forEach(function(el) {
    var minD = parseInt(el.dataset.minDays, 10) || 3;
    var maxD = parseInt(el.dataset.maxDays, 10) || 7;
    var opts = { month: 'short', day: 'numeric' };
    var from = new Date(); from.setDate(from.getDate() + minD);
    var to = new Date(); to.setDate(to.getDate() + maxD);
    var rangeEl = el.querySelector('.pe-delivery__range');
    if (rangeEl) rangeEl.textContent = from.toLocaleDateString('en-US', opts) + ' — ' + to.toLocaleDateString('en-US', opts);
  });

  // Helper: format money simply
  function fmtMoney(cents) {
    var sym = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? '' : '$';
    return sym + '$'.replace('$', '$') + (cents / 100).toFixed(2);
  }
  function simpleMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  // Free shipping progress bar
  document.querySelectorAll('.pe-ship').forEach(function(el) {
    var threshold = parseInt(el.dataset.threshold, 10) || 9900;
    var msgBefore = el.dataset.before || 'Add [amount] more for FREE shipping!';
    var msgAfter = el.dataset.after || 'You qualify for FREE shipping!';
    var msgEl = el.querySelector('.pe-ship__message');
    var fillEl = el.querySelector('.pe-ship__fill');

    function render(cartTotal) {
      var pct = Math.min(100, (cartTotal / threshold) * 100);
      fillEl.style.width = pct + '%';
      if (cartTotal >= threshold) {
        msgEl.textContent = msgAfter;
        el.classList.add('pe-ship--complete');
      } else {
        var remaining = threshold - cartTotal;
        msgEl.textContent = msgBefore.replace('[amount]', simpleMoney(remaining));
        el.classList.remove('pe-ship--complete');
      }
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { render(cart.total_price || 0); })
      .catch(function() { msgEl.textContent = msgBefore.replace('[amount]', simpleMoney(threshold)); });
  });

  // Size guide modal
  document.querySelectorAll('.pe-sg').forEach(function(el) {
    var modal = el.querySelector('.pe-sg__modal');
    if (!modal) return;
    el.querySelectorAll('[data-open]').forEach(function(b) {
      b.addEventListener('click', function() {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    el.querySelectorAll('[data-close]').forEach(function(b) {
      b.addEventListener('click', function() {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });
    // ESC to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  });

  // Recently viewed (localStorage)
  document.querySelectorAll('.pe-recent').forEach(function(el) {
    var handle = el.dataset.handle;
    var max = parseInt(el.dataset.max, 10) || 4;
    var heading = el.dataset.heading || 'Recently viewed';
    var key = 'glitch_recent_viewed';

    var viewed = [];
    try { viewed = JSON.parse(localStorage.getItem(key) || '[]'); } catch(e) {}

    viewed = viewed.filter(function(h) { return h !== handle; });
    viewed.unshift(handle);
    viewed = viewed.slice(0, 20);
    try { localStorage.setItem(key, JSON.stringify(viewed)); } catch(e) {}

    var toShow = viewed.filter(function(h) { return h !== handle; }).slice(0, max);
    if (!toShow.length) { el.style.display = 'none'; return; }

    Promise.all(toShow.map(function(h) {
      return fetch('/products/' + h + '.js').then(function(r) { return r.ok ? r.json() : null; }).catch(function() { return null; });
    })).then(function(products) {
      var valid = products.filter(function(p) { return p; });
      if (!valid.length) { el.style.display = 'none'; return; }
      var html = '<p class="pe-recent__heading">' + heading + '</p><div class="pe-recent__list">';
      valid.forEach(function(p) {
        var img = p.featured_image ? p.featured_image + '&width=200' : '';
        html += '<a href="' + p.url + '" class="pe-recent__item">' +
          (img ? '<img src="' + img + '" alt="" class="pe-recent__img" loading="lazy">' : '<div class="pe-recent__img"></div>') +
          '<p class="pe-recent__title">' + p.title + '</p>' +
          '<p class="pe-recent__price">' + simpleMoney(p.price) + '</p>' +
          '</a>';
      });
      html += '</div>';
      el.innerHTML = html;
    });
  });

  // Frequently bought together (Shopify recommendations API)
  document.querySelectorAll('.pe-bt').forEach(function(el) {
    var productId = el.dataset.productId;
    var limit = parseInt(el.dataset.limit, 10) || 3;
    var heading = el.dataset.heading || 'Frequently bought together';
    var button = el.dataset.button || 'Add all to cart';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=complementary')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          // Fallback: try related
          return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
            .then(function(r) { return r.json(); })
            .then(function(d) { return (d && d.products) || []; });
        }
        return products;
      })
      .then(function(products) {
        if (!products.length) { el.style.display = 'none'; return; }
        var html = '<p class="pe-bt__heading">' + heading + '</p><div class="pe-bt__items">';
        products.forEach(function(p) {
          var img = p.featured_image ? p.featured_image + '&width=200' : '';
          var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
          if (!variantId) return;
          html += '<label class="pe-bt__item">' +
            '<input type="checkbox" data-variant="' + variantId + '" data-price="' + p.price + '" checked>' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<div>' +
              '<p class="pe-bt__title">' + p.title + '</p>' +
              '<p class="pe-bt__price">' + simpleMoney(p.price) + '</p>' +
            '</div>' +
            '</label>';
        });
        html += '</div>' +
          '<p class="pe-bt__total"><span>Total:</span> <span class="pe-bt__total-price">' + simpleMoney(0) + '</span></p>' +
          '<button type="button" class="pe-bt__add-all">' + button + '</button>';
        el.innerHTML = html;

        function updateTotal() {
          var total = 0;
          el.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
            total += parseInt(cb.dataset.price, 10) || 0;
          });
          el.querySelector('.pe-bt__total-price').textContent = simpleMoney(total);
        }
        updateTotal();
        el.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
          cb.addEventListener('change', updateTotal);
        });

        el.querySelector('.pe-bt__add-all').addEventListener('click', function() {
          var btn = this;
          var items = [];
          el.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
            items.push({ id: parseInt(cb.dataset.variant, 10), quantity: 1 });
          });
          if (!items.length) return;
          btn.disabled = true;
          btn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function(r) { return r.json(); })
            .then(function() { window.location.href = '/cart'; })
            .catch(function() {
              btn.disabled = false;
              btn.textContent = button;
              alert('Something went wrong. Please try again.');
            });
        });
      })
      .catch(function() { el.style.display = 'none'; });
  });

})();
